import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link } from '../Link';
import { ButtonV2 as Button } from '../Button';
import { ChevronButton } from '../ChevronButton';
import ArrowButton from '../ArrowButton/ArrowButton';
import scrollViewTo from '../../util/scrollViewTo';

import './drawer.less';

const ALLOWED_BACKGROUND_CLASSES = [
  'fade-bottom--secondary-gray',
  'fade-bottom--background-gray',
  '',
];

/**
 * @deprecated components/Drawer is deprecated, use components/DrawerV2
 */
class Drawer extends Component {
  constructor(props) {
    super(props);
    this.toggleSection = this.toggleSection.bind(this);
    this.renderButtons = this.renderButtons.bind(this);
    this.state = { sectionExpanded: props.expandedByDefault };
    this.topOfFAQs = React.createRef();
  }

  toggleSection() {
    const { offset, skipScrollToTop } = this.props;
    this.setState((prevState) => {
      if (prevState.sectionExpanded && !skipScrollToTop) {
        scrollViewTo({ el: this.topOfFAQs.current, offset });
      }
      return { sectionExpanded: !prevState.sectionExpanded };
    });
  }

  renderButtons(sectionExpanded) {
    const { buttonText, arrowV2 } = this.props;
    if (buttonText.open && buttonText.close) {
      return (
        <div>
          {buttonText.appearance === 'button' ? (
            <Button className="drawer__button" onClick={this.toggleSection} variant="secondary">
              {sectionExpanded ? buttonText.close : buttonText.open}
            </Button>
          ) : (
            <Link className="drawer__button-link" onClick={this.toggleSection} role="button">
              {sectionExpanded ? buttonText.close : buttonText.open}
            </Link>
          )}
        </div>
      );
    }
    const renderArrows = () => {
      if (arrowV2) {
        return (
          <ArrowButton
            component="button"
            onClick={this.toggleSection}
            direction={sectionExpanded ? 'up' : 'down'}
            aria-label={sectionExpanded ? 'close section' : 'expand section'}
            smaller
          />
        );
      }
      return (
        <ChevronButton
          direction={sectionExpanded ? 'up' : 'down'}
          btnStyle="secondary"
          onClick={this.toggleSection}
          ariaLabel={sectionExpanded ? 'close section' : 'expand section'}
        />
      );
    };
    return renderArrows();
  }

  render() {
    const { sectionExpanded } = this.state;
    const {
      backgroundOverrideClass,
      children,
      className,
      maxHeight,
      maxExpandedHeight,
      drawerV2 = false,
    } = this.props;

    const currentHeight = sectionExpanded ? maxExpandedHeight : maxHeight;

    const classes = cx({ 'zola-ui': !drawerV2 }, 'drawer', className, backgroundOverrideClass);

    return (
      <div ref={this.topOfFAQs} className={`${classes}${sectionExpanded ? '' : ' fade-bottom'}`}>
        <div className="drawer__content" style={{ maxHeight: currentHeight }}>
          {children}
        </div>
        <div className="drawer__expand-button-container">{this.renderButtons(sectionExpanded)}</div>
      </div>
    );
  }
}

Drawer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  /**
   *  Default expanding state. This value will not change it after the component is rendered
   */
  expandedByDefault: PropTypes.bool,
  backgroundOverrideClass: PropTypes.oneOf(ALLOWED_BACKGROUND_CLASSES),
  /**
   * Max height when drawer is closed
   */
  maxHeight: PropTypes.string.isRequired,
  /**
   * Max height when drawer is expanded
   * */
  maxExpandedHeight: PropTypes.string,
  offset: PropTypes.number,
  skipScrollToTop: PropTypes.bool,
  arrowV2: PropTypes.bool,
  drawerV2: PropTypes.bool,
  /* Replace default Chevron Button */
  buttonText: PropTypes.shape({
    open: PropTypes.string,
    close: PropTypes.string,
    appearance: PropTypes.oneOf(['button', 'link']),
  }),
};

Drawer.defaultProps = {
  offset: 0,
  maxExpandedHeight: '3000px',
  backgroundOverrideClass: '',
  expandedByDefault: false,
  buttonText: {
    open: null,
    close: null,
    appearance: 'link',
  },
  arrowV2: false,
  drawerV2: false,
};

export default Drawer;
